import React from 'react';

import styled, { css } from 'styled-components';

import { Tooltip, Icon, theme } from 'fpay-ui';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import parse from 'html-react-parser';

export const TextoFpay = styled.div`
  text-align: center;
  font-size: 12px;
  letter-spacing: 0;
  color: ${theme.colors.gray800};
  opacity: 1;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 180px;
  padding: 12px;
`;

export const IconInfo = styled(Icon)`
  margin-left: 5px;
`;

const ContIcon = styled.div(
  ({ theme }) => css`
    display: flex;
    cursor: pointer;
    ${theme.breakpoint('ll')} {
      display: none;
    }
  `
);

const Layout = styled.div(
  ({ theme }) => css`
    display: flex;
    padding-bottom: ${(props) => props.paddingBottomSM || '0px'};
    padding-top: ${(props) => props.paddingTopSM || '0px'};
    ${theme.breakpoint('ll')} {
      padding-bottom: ${(props) => props.paddingBottomLG || '0px'};
      padding-top: ${(props) => props.paddingTopLG || '0px'};
    }
  `
);

const TooltipToModal = ({
  handleClick,
  tooltipPosition,
  tooltipText,
  paddingBottomSM,
  paddingTopSM,
  paddingBottomLG,
  paddingTopLG,
  id,
  breaks = '',
  className = '',
  iconName = 'tooltip-info',
  width = '16px',
  height = '16px',
  color = theme.colors.gray500,
  htmlIdTooltip
}) => {
  const { breakpoint } = useBreakpoints();

  return (
    <Layout
      className={className}
      paddingBottomSM={paddingBottomSM}
      paddingTopSM={paddingTopSM}
      paddingTopLG={paddingTopLG}
      paddingBottomLG={paddingBottomLG}
    >
      {[{ breaks }].includes(breakpoint) ? (
        <ContIcon onClick={handleClick} testId={`tooltip-${id}`} id={htmlIdTooltip}>
          <IconInfo icon={iconName} width={width} height={height} color={color} />
        </ContIcon>
      ) : (
        <Tooltip position={tooltipPosition || 'bottom-right'} duration={100} width="190px" htmlIdTooltip={htmlIdTooltip}>
          <IconInfo icon={iconName} width={width} height={height} color={color} />
          <TextoFpay>{parse(tooltipText)}</TextoFpay>
        </Tooltip>
      )}
    </Layout>
  );
};

export default TooltipToModal;
